/**
 * <oppie-video-card> — opens a lightweight modal with the card's video
 * (YouTube, Vimeo or direct MP4) when the user clicks the card or play button.
 * No deps. Falls back to a no-op when the data-video-url is absent.
 */
class OppieVideoCard extends HTMLElement {
  connectedCallback() {
    this.url = this.dataset.videoUrl;
    if (!this.url) return;
    this.addEventListener('click', (e) => {
      e.preventDefault();
      this.#open();
    });
  }

  #embedFor(url) {
    let m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]+)/);
    if (m) return `<iframe src="https://www.youtube.com/embed/${m[1]}?autoplay=1&rel=0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
    m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (m) return `<iframe src="https://player.vimeo.com/video/${m[1]}?autoplay=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    return `<video src="${url}" controls autoplay playsinline></video>`;
  }

  #open() {
    const embed = this.#embedFor(this.url);
    const dialog = document.createElement('div');
    // Eigen videobestand (vaak staand 9:16): op mobiel schermvullend, geen 16:9-kader.
    dialog.className = embed.startsWith('<video') ? 'oppie-video-modal oppie-video-modal--file' : 'oppie-video-modal';
    dialog.innerHTML = `
      <div class="oppie-video-modal__scrim" data-close></div>
      <div class="oppie-video-modal__frame">
        <button type="button" class="oppie-video-modal__close" data-close aria-label="Sluiten">×</button>
        <div class="oppie-video-modal__media">${embed}</div>
      </div>
    `;
    const close = () => {
      dialog.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    };
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    dialog.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    document.body.appendChild(dialog);
  }
}
if (!customElements.get('oppie-video-card')) {
  customElements.define('oppie-video-card', OppieVideoCard);
}
